@if (isLoading) {
    <div class="fancy-loader submodule my-4"></div>
} @else if (config) {
    <div class="detail-page-action-bar flex-action-bar">
        <div></div>
        <div class="right-area">
            <button (click)="createTemplateDatasets()" class="btn btn-dark">
                <i class="fas fa-plus me-2"></i>
                {{ 'devPowerBi.createTemplates' | t }}
            </button>
        </div>
    </div>

    <generic-list-manager [config]="config"></generic-list-manager>
} @else {
    <span>{{ 'devPowerBi.notEnabled' | t }}</span>
}
